/**
 * Amounts are integers in minor units end to end (wire, domain, storage).
 * This is the only place a minor-units integer becomes a display string —
 * never round-trip the output of this function back into a request body.
 */
export function formatMinorUnits(amountMinorUnits: number, currency: string, locale = 'es-ES'): string {
  return new Intl.NumberFormat(locale, {
    style: 'currency',
    currency,
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(amountMinorUnits / 100);
}
